import { BATTLESHIP, KOALA, OLAF } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIList from 'UIComponents/list/UIList';
import styled from 'styled-components';

/** WRAPPER STYLED COMPONENTS */
export const StyledDataTokenPopoverWrapper = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledDataTokenPopoverWrapper",
  componentId: "sc-1i1vl5q-0"
})(["background:", ";border-radius:3px;border:1px solid ", ";position:absolute;width:250px;z-index:2000;"], OLAF, BATTLESHIP);
export const StyledIndicatorTopArrowWrapper = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledIndicatorTopArrowWrapper",
  componentId: "sc-1i1vl5q-1"
})(["height:11px;left:10px;overflow:hidden;position:relative;top:-10px;"]);
export const StyledIndicatorTopArrow = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledIndicatorTopArrow",
  componentId: "sc-1i1vl5q-2"
})(["background:", ";border:1px solid ", ";height:20px;position:relative;top:3px;transform:rotate(45deg);width:20px;"], OLAF, BATTLESHIP);
export const StyledIndicatorArrowBottomWrapper = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledIndicatorArrowBottomWrapper",
  componentId: "sc-1i1vl5q-3"
})(["height:11px;left:10px;overflow:hidden;position:relative;top:11px;"]);
export const StyledIndicatorBottomArrow = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledIndicatorBottomArrow",
  componentId: "sc-1i1vl5q-4"
})(["background:", ";border:1px solid ", ";height:20px;position:relative;top:-13px;transform:rotate(45deg);width:20px;"], OLAF, BATTLESHIP);

/** MAIN MENU STYLED COMPONENTS */
export const StyledUIList = styled(UIList).withConfig({
  displayName: "DataTokenStyle__StyledUIList",
  componentId: "sc-1i1vl5q-5"
})(["margin:0;padding:0;li{padding:0;}"]);
export const StyledDataTokenInfo = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledDataTokenInfo",
  componentId: "sc-1i1vl5q-6"
})(["font-size:14px;padding-bottom:8px !important;padding-left:20px !important;padding-right:16px !important;"]);

/** SUB MENU STYLED COMPONENTS */
export const StyledSubMenuOuterWrapper = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledSubMenuOuterWrapper",
  componentId: "sc-1i1vl5q-7"
})(["height:0.001px;"]);
export const StyledSubMenuWrapper = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledSubMenuWrapper",
  componentId: "sc-1i1vl5q-8"
})(["background:", ";border-radius:3px;border:1px solid ", ";position:relative;width:250px;z-index:10000;"], OLAF, BATTLESHIP);

/** COMMON STYLED COMPONENTS */
export const StyledHorizontalBreak = styled.div.withConfig({
  displayName: "DataTokenStyle__StyledHorizontalBreak",
  componentId: "sc-1i1vl5q-9"
})(["background:", ";height:1px;margin:0;overflow:hidden;"], BATTLESHIP);
export const StyledUIButton = styled(UIButton).withConfig({
  displayName: "DataTokenStyle__StyledUIButton",
  componentId: "sc-1i1vl5q-10"
})(["font-size:14px;overflow:hidden;padding-bottom:8px !important;padding-left:20px !important;padding-right:6px !important;padding-top:8px !important;text-overflow:ellipsis;white-space:nowrap;width:100%;:hover{background:", ";}"], KOALA);
export const StyledUIIconButton = styled(UIIconButton).withConfig({
  displayName: "DataTokenStyle__StyledUIIconButton",
  componentId: "sc-1i1vl5q-11"
})(["display:flex;font-size:14px !important;justify-content:space-between;overflow:hidden;padding-bottom:8px !important;padding-left:20px !important;padding-right:6px !important;padding-top:8px !important;text-overflow:ellipsis;white-space:nowrap;width:100% !important;:hover{background:", ";}"], KOALA);